import React from 'react';

class BridgeWeightSelector extends React.Component {
	constructor(props) {
		super(props)
		this.truck = this.props.truck;
		this.bridgeWeights = this.truck.calculateBridgeWeights();
		this.state = {
			firstAxle: 0,
			lastAxle: this.truck.axleCount-1,
			bridgeWeight: 0
		}
	}

	handleChange(isFirstAxle, event) {
		if (!isFirstAxle) {
			this.setState({lastAxle: parseInt(event.target.value)});
		} else {
			this.setState({firstAxle: parseInt(event.target.value)});
		}

		
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			(prevState.firstAxle !== this.state.firstAxle ||
			prevState.lastAxle !== this.state.lastAxle) &&
			(this.state.firstAxle !== -1 && this.state.lastAxle !== -1)
			) {
				let legalWeightIndex = 0;
				for (let i = 0; i < this.bridgeWeights.startAxle.length; ++i) {
					if (this.bridgeWeights.startAxle[i] === this.state.firstAxle &&
						this.bridgeWeights.endAxle[i] === this.state.lastAxle) {
							legalWeightIndex = i;
							break;
						}
				}
				this.setState({bridgeWeight: this.bridgeWeights.weight9Ton[legalWeightIndex]})
			}
	}

	render() {
		return (
			<div className='bridgeWeightSelector'>
				<BridgeWeightSelectorInput truck={this.truck} state={this.state} isFirstAxle={true} onChange={this.handleChange.bind(this, true)} />
				to
				<BridgeWeightSelectorInput truck={this.truck} state={this.state} isFirstAxle={false} onChange={this.handleChange.bind(this, false)} />
				{this.state.bridgeWeight} lbs.
			</div>
		);
	}
}

class BridgeWeightSelectorInput extends React.Component {
	constructor(props) {
		super(props)
		this.truck = this.props.truck
		this.state = this.props.state
		this.isFirstAxle = this.props.isFirstAxle
	}

	render() {
		let selectInputOptions = [];

		selectInputOptions.push(<option key={-1} value={-1}>Select Axle</option>);
		for (let i = this.state.firstAxle; i < this.truck.axleCount; ++i) {
			selectInputOptions.push(<option key={i} value={i}>{i+1}</option>);
		}

		
		return (
			<div>
				<select onChange={this.props.onChange}>{selectInputOptions}</select>
			</div>
			
		);
	}
}

export default BridgeWeightSelector;


// WEBPACK FOOTER //
// ./src/Minnesota/MNOutput/BridgeWeightSelector.js